/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getSubcmpniesList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_SUBCOMPANY, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getSubcmpnyDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_SUBCOMPANY_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addSubcompany: (data) => {
    return axios.post(API_ENDPOINTS.ADD_SUBCOMPANY, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  updateSubcmpny: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_SUBCOMPANY_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  deleteSubcompany: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_SUBCOMPANY_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getallsubcmpniesnamelist:() => {
    return axios.get(API_ENDPOINTS.GET_ALL_SUBCOMPANY_NAMES, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
};
